import React from "react";
import MenuNews from "./MenuNews";
import { useState } from "react";



function News (props){
    const [menuActive,setMenuActive]=useState(false)
    const [menuActive1,setMenuActive1]=useState(false)
    

     
    return(
        <div className="information n">
        <button type="button" className="btn btn-secondary new" onClick={()=> setMenuActive(!menuActive)} ><a>Изменения
            <span className="badge bg-danger y">1</span>
            </a></button>
            <MenuNews active={menuActive} setActive={setMenuActive}  sid={props.sid}/>
            <button type="button" className="btn btn-secondary new" onClick={()=> setMenuActive1(!menuActive1)} ><a>Новое
                <span className="badge bg-danger y">0</span>
                </a></button>
            <MenuNews active={menuActive1} setActive={setMenuActive1} sid={props.sid}/>
            
            
            
            </div>






    )
}


export default News